<template>
  <svg
    v-if="paths.length"
    class="proto-icon"
    viewBox="0 0 24 24"
    :width="size"
    :height="size"
    aria-hidden="true"
  >
    <path v-for="(d, i) in paths" :key="i" :d="d" />
  </svg>
</template>

<script>
// Ícones no estilo do protótipo Interativa (traço fino, Lucide/Feather).
// Chaveados pelos MESMOS nomes usados nos fluent-icons para troca mínima.
const ICONS = {
  chat: ['M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2Z'],
  edit: [
    'M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7',
    'M18.5 2.5a2.1 2.1 0 0 1 3 3L12 15l-4 1 1-4Z',
  ],
  merge: [
    'M9 15a6 6 0 1 0 0-12 6 6 0 0 0 0 12Z',
    'M15 21a6 6 0 1 0 0-12 6 6 0 0 0 0 12Z',
  ],
  send: ['m22 2-7 20-4-9-9-4Z', 'M22 2 11 13'],
  delete: [
    'M3 6h18',
    'M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2',
    'M10 11v6M14 11v6',
  ],
  add: ['M12 5v14M5 12h14'],
  person: [
    'M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2',
    'M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z',
  ],
  'people-team': [
    'M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2',
    'M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z',
    'M23 21v-2a4 4 0 0 0-3-3.9M16 3.1a4 4 0 0 1 0 7.8',
  ],
  'people-team-add': [
    'M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2',
    'M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z',
    'M19 8v6M22 11h-6',
  ],
  attach: [
    'm21.4 11.1-9 9a5.5 5.5 0 0 1-7.8-7.8l9-9a3.7 3.7 0 0 1 5.2 5.2l-9 9a1.8 1.8 0 0 1-2.6-2.6l8.3-8.3',
  ],
  location: [
    'M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z',
    'M12 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z',
  ],
  emoji: [
    'M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20Z',
    'M8 14s1.5 2 4 2 4-2 4-2',
    'M9 9h.01M15 9h.01',
  ],
  microphone: [
    'M12 2a3 3 0 0 0-3 3v6a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Z',
    'M19 10a7 7 0 0 1-14 0',
    'M12 19v3',
  ],
  'microphone-off': [
    'M12 2a3 3 0 0 0-3 3v6a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Z',
    'M19 10a7 7 0 0 1-14 0',
    'M12 19v3',
    'M2 2l20 20',
  ],
  quote: [
    'M6 9H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v4c0 2-1 3-3 4',
    'M16 9h-2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v4c0 2-1 3-3 4',
  ],
  signature: [
    'M20 12v6a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h6',
    'M18.4 2.6a2 2 0 0 1 2.8 2.8L12 14l-4 1 1-4Z',
  ],
  'memo-pad': [
    'M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-2',
    'M9 2h6a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1Z',
    'M8 12h8M8 16h5',
  ],
  whatsapp: [
    'M12 2a10 10 0 0 0-8.5 15.3L2 22l4.9-1.4A10 10 0 1 0 12 2Z',
    'M8.5 8.5c.3 2 1.5 3.5 3 4.5 1 .7 2 .3 2.5-.5',
  ],
  share: [
    'M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8',
    'M16 6l-4-4-4 4',
    'M12 2v13',
  ],
  'speaker-mute': ['M11 5 6 9H2v6h4l5 4V5Z', 'M22 9l-6 6M16 9l6 6'],
  'speaker-1': ['M11 5 6 9H2v6h4l5 4V5Z', 'M15.5 8.5a5 5 0 0 1 0 7'],
  checkmark: ['M20 6 9 17l-5-5'],
  grid: ['M3 3h7v7H3z', 'M14 3h7v7h-7z', 'M14 14h7v7h-7z', 'M3 14h7v7H3z'],
  // Headers de seção (accordion do painel de contato/conversa)
  assignment: [
    'M20 7h-9M14 17H5',
    'M17 17a3 3 0 1 0 6 0 3 3 0 0 0-6 0Z',
    'M7 7a3 3 0 1 0-6 0 3 3 0 0 0 6 0Z',
  ],
  people: [
    'M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2',
    'M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z',
  ],
  info: ['M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Z', 'M12 16v-4', 'M12 8h.01'],
  list: ['M8 6h13M8 12h13M8 18h13', 'M3 6h.01M3 12h.01M3 18h.01'],
  wallet: [
    'M19 7V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-2',
    'M21 12a2 2 0 0 0-2-2h-4a2 2 0 0 0 0 4h4a2 2 0 0 0 2-2Z',
  ],
  history: ['M3 3v5h5', 'M3.05 13A9 9 0 1 0 6 5.3L3 8', 'M12 7v5l4 2'],
  ticket: [
    'M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z',
    'M13 5v14',
  ],
  bolt: ['M13 2 3 14h9l-1 8 10-12h-9l1-8Z'],
  tag: ['M20.6 13.4 12 22l-9-9V3h10l7.6 7.6a2 2 0 0 1 0 2.8Z', 'M7 7h.01'],
};

export default {
  name: 'ProtoIcon',
  props: {
    name: { type: String, default: '' },
    size: { type: [String, Number], default: 18 },
  },
  computed: {
    paths() {
      return ICONS[this.name] || [];
    },
  },
};
</script>

<style lang="scss" scoped>
.proto-icon {
  display: block;
  flex: none;
  fill: none;
  stroke: currentColor;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
}
</style>
